import { Link } from "react-router-dom";
import { money } from "@/lib/api";

export default function ArtworkCard({ art }) {
  const sold = art.status === "sold";
  const pending = art.status === "pending";
  return (
    <Link to={`/artwork/${art.id}`} data-testid={`artwork-card-${art.id}`}
      className="art-card group block bg-white rounded-xl overflow-hidden border border-[var(--border-subtle)]">
      <div className="relative aspect-[4/5] overflow-hidden bg-[var(--bg-secondary)]">
        <img src={art.image_url} alt={art.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-3 left-3">
          <span className="overline-badge bg-white/90 px-2.5 py-1 rounded-full">{art.category}</span>
        </div>
        {(sold || pending) && (
          <div className="absolute top-3 right-3">
            <span className={`text-[0.65rem] font-mono uppercase tracking-wider px-2.5 py-1 rounded-full ${
              sold ? "bg-stone-900 text-white" : "bg-amber-100 text-amber-800"}`}>
              {sold ? "Sold" : "Reserved"}
            </span>
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-serif text-xl text-[var(--text-primary)] leading-tight">{art.title}</h3>
            <p className="text-sm text-[var(--text-muted)] mt-0.5">{art.artist_name}</p>
          </div>
          <span className="font-mono text-sm text-[var(--text-primary)] whitespace-nowrap">{money(art.price)}</span>
        </div>
      </div>
    </Link>
  );
}
